module.exports = __webpack_public_path__ + "static/media/operations_use_case_4.3d6cc119.svg";